// Angular
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '@app/views/pages/transpop/cart1/cart.service';
import { AppConsts } from '@shared/AppConsts';

@Component({
	selector: 'kt-cart',
	templateUrl: './cart.component.html',
	styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit, AfterViewInit {
	// Public properties

	// Set icon class name
	@Input() icon = 'flaticon2-shopping-cart-1';
	@Input() iconType: '' | 'brand';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	@Input() badgeValue : number = 0;

	/**
	 * Component constructor
	 */
	constructor(
		public cartService : CartService,
		private _router : Router
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {
	}

	/**
	 * On init
	 */
	ngOnInit(): void {
	}

	gotoCartPage(){
		this._router.navigate(['app/cart']);
	}

	getPhotoUrl(kod: string): string {

		return  AppConsts.productImage.url + '/' + kod + '.jpg';

	}
}
